import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { useAppStore } from '../../store';

export const TeamPerformanceChart = () => {
  const tasks = useAppStore((state) => state.tasks);
  const teams = useAppStore((state) => state.teams);

  const generateChartData = () => {
    return teams.map(team => {
      const teamTasks = tasks.filter(task => 
        task.assignedTo?.some(memberId => 
          team.members.includes(memberId)
        )
      );

      const completed = teamTasks.filter(task => 
        task.status === 'Completed'
      ).length;

      const inProgress = teamTasks.filter(task => 
        task.status === 'In Progress'
      ).length;

      return {
        name: team.name,
        completed,
        inProgress
      };
    });
  };

  const data = generateChartData();

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar 
          dataKey="completed" 
          name="Completed Tasks" 
          fill="#4b39ef"
          radius={[4, 4, 0, 0]} 
        />
        <Bar 
          dataKey="inProgress" 
          name="In Progress" 
          fill="#39d2c0"
          radius={[4, 4, 0, 0]} 
        />
      </BarChart>
    </ResponsiveContainer>
  );
};